<template>
    <v-app>
        <v-content>
            <nprogress-container></nprogress-container>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

export default {
    name: "App",
    data() {
        return {};
    },
    computed: {
        user() {
            return this.$store.state.user;
        }
    },
    components: {
        NprogressContainer
    }
};
</script>

<style lang="scss">
    @import "./scss/app.scss";

    .v-content {
        background-color: #f1f2f6;
    }

    #nprogress .bar {
        background: #ff9100;
    }

    #nprogress .spinner-icon {
        border-top-color: transparent;
        border-left-color: transparent;
    }
</style>
